import { Badge } from "@circleco/compass/components/Badge";
import type { MenuOptions } from "@circleco/compass/components/Menu";
import { Link } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";

import { adminV4Icons } from "../adminV4Icons";

export const useGetModerationMenu = (
  moderationCount: number | undefined,
): MenuOptions[number] => ({
  label: t("sidebar_moderation"),
  icon: adminV4Icons.moderationIcon,
  renderLink: <Link to="/settings/moderation" />,
  ...(moderationCount && {
    suffix: <Badge label={String(moderationCount)} variant="primary" />,
  }),
});
